import { generateDate } from '../../../common/utils/date.js'
import { UiFloatModal } from '../../../common/modal/index.js'

const locale = () => ({
    days: [i18next.t("interval_sunday"), i18next.t("interval_monday"), i18next.t("interval_tuesday"), i18next.t("interval_wednesday"), i18next.t("interval_thursday"), i18next.t("interval_friday"), i18next.t("interval_saturday")],
    daysShort: [i18next.t("interval_sun"), i18next.t("interval_mon"), i18next.t("interval_tue"), i18next.t("interval_wed"), i18next.t("interval_thu"), i18next.t("interval_fri"), i18next.t("interval_sat")],
    daysMin: [i18next.t("interval_su"), i18next.t("interval_mo"), i18next.t("interval_tu"), i18next.t("interval_we"), i18next.t("interval_th"), i18next.t("interval_fr"), i18next.t("interval_sa")],
    months: [i18next.t("interval_january"), i18next.t("interval_february"), i18next.t("interval_march"), i18next.t("interval_april"), i18next.t("interval_may"), i18next.t("interval_june"), i18next.t("interval_july"), i18next.t("interval_august"), i18next.t("interval_september"), i18next.t("interval_october"), i18next.t("interval_november"), i18next.t("interval_december")],
    monthsShort: [i18next.t("interval_jan"), i18next.t("interval_feb"), i18next.t("interval_mar"), i18next.t("interval_apr"), i18next.t("interval_ma"), i18next.t("interval_jun"), i18next.t("interval_jul"), i18next.t("interval_aug"), i18next.t("interval_sep"), i18next.t("interval_oct"), i18next.t("interval_nov"), i18next.t("interval_dec")],
    today: i18next.t("interval_today"),
    clear: i18next.t("interval_clear"),
    dateFormat: 'dd.MM.yyyy',
    timeFormat: 'HH:mm',
    firstDay: 1
});

const selectValeus = {
    0: {
        division: 4,
        resampleInterval: 1,
        formattime: "MM.yyyy",
        options: {
            view: "months",
            minView: "months",
            dateFormat: "MM.yyyy"
        }
    },
    1: {
        division: 3,
        resampleInterval: 1,
        formattime: "dd.MM.yyyy",
        options: {
            view: "days",
            minView: "days",
            dateFormat: "dd.MM.yyyy"
        }
    },
    2: {
        division: 2,
        resampleInterval: 1,
        formattime: "dd.MM.yyyy HH:mm",
        options: {
            view: "days",
            timeFormat: 'hh:mm',
            timepicker: true,
        }
    }
}

const generateInputDate = (date) => {
    const valueDate = new Date(date);
    const day = ("0" + valueDate.getDate()).slice(-2);
    const month = ("0" + (valueDate.getMonth() + 1)).slice(-2);
    return valueDate.getFullYear() + "-" + (month) + "-" + (day)
}

const generateInputDateTime = (date) => {
    var valueDate = new Date(date);
    valueDate.setMinutes(valueDate.getMinutes() - valueDate.getTimezoneOffset());
    return valueDate.toISOString().slice(0, 16)
}

const renderInputs = (division = 4, archivestart = "", archiveend = "") => {
    if (division === 4) {
        archivestart = generateInputDate(archivestart)
        archiveend = generateInputDate(archiveend)
    } else {
        archivestart = generateInputDateTime(archivestart)
        archiveend = generateInputDateTime(archiveend)
    }
    return `
        <div>
            <div class="interval-title">${i18next.t("interval_division")}</div>
            <select id="select-value" name=${i18next.t("trend_legend_value")} class="pointer">
                <option value="0"  ${division === 0 ? 'selected' : ''}>${i18next.t("interval_month")}</option>
                <option value="1" ${division === 1 ? 'selected' : ''}>${i18next.t("interval_day")}</option>
                <option value="2" ${division === 2 ? 'selected' : ''}>${i18next.t("interval_short_hour")}</option>
            </select>
        </div>
        <div>
            <div class="interval-title">${i18next.t("interval_from")}</div>
            <div class="interval-dp-wrap top">
                <input readonly id="dp-input-start" type="text" placeholder=${i18next.t("interval_start_of_archive")} class="interval-dp-input" />
            </div>
            <div class="interval-title">${i18next.t("interval_to")}</div>
            <div class="interval-dp-wrap">
                <input readonly type="text" placeholder=${i18next.t("interval_end_of_archive")} id="dp-input-end" class="interval-dp-input" />
            </div>
        </div>
` }

const template = () => `
        <style>
            @import "controls/chartcolumn/popups/interval/interval.css";
        </style>
        <div class="interval-container">
            <div id="interval-content"> 
                ${renderInputs}
            </div>
            <div class="interval-buttons-wrap">
                <div id="interval-btn-apply" class="interval-btn">${i18next.t("apply")}</div>
                <div id="interval-btn-cancel" class="interval-btn">${i18next.t("cancel")}</div>
            </div>
        </div>`;

/**
 * @class ChartMenuInterval
 * @classdesc Окно настройки интервалов
 * */
export class ChartMenuInterval {

    constructor(container, root) {
        this.container = container
        this.root = root
        this.state = this.root.root.state
        this._selected = 0
        this.copy = {
            division: this.state.division,
            archivestart: this.state.archivestart,
            archiveend: this.state.archiveend,
            formattime: this.root.formattime,
            resampleInterval: 1,
        }
        this.initModal()
        this.render()
        this.initSelect()
    }

    initCopy() {
        this.copy = {
            division: this.state.division,
            archivestart: this.state.archivestart,
            archiveend: this.state.archiveend,
            resampleInterval: this.state.resampleInterval
        }
    }

    initSelect() {
        switch (this.state.division) {
            case (4):
                this.selected = 0;
                break;
            case (3):
                this.selected = 1;
                break;
            case (2):
                this.selected = 2;
                break;
            default:
                this.selected = 0;
                break;
        }
    }

    initDatepicker() {
        const { options } = selectValeus[this.selected]
        const opt = { ...options, locale: locale(), autoClose: true };
        const optStart = {
            ...opt,
            onSelect: this.onStartChange.bind(this),
            selectedDates: [this.copy.archivestart]
        }
        const optEnd = {
            ...opt,
            onSelect: this.onEndChange.bind(this),
            selectedDates: [this.copy.archiveend]
        }
        const elemStart = this.modal.modalComponent.querySelector(`#dp-input-start`)
        const elemEnd = this.modal.modalComponent.querySelector(`#dp-input-end`)
        this.dpStart = new AirDatepicker(elemStart, optStart);
        this.dpEnd = new AirDatepicker(elemEnd, optEnd);
        this.dpStart.init();
        this.dpEnd.init();
    }

    initModal() {
        this.modal = new UiFloatModal(template())
        this.applyBtn = this.modal.modalComponent.querySelector('#interval-btn-apply')
        this.cancelBtn = this.modal.modalComponent.querySelector('#interval-btn-cancel')
        this.modal.modalComponent.calculateInitialPosition = () => {
            const { top, left } = this.root.root.getBoundingClientRect()
            return [left, top]
        }
        this.applyBtn.addEventListener('click', (e) => this.onOkClick(e))
        this.cancelBtn.addEventListener('click', (e) => this.onCancelClick.bind(this)())
        this.modal.modalComponent.label = i18next.t("interval_setting_intervals");
    }

    onCancelClick(e) {
        this.updateCopyValues()
        this.render()
        this.modal?.modalComponent.close()
    }

    onOkClick(e) {
        if ($pm.hasPermissions) {
            const options = {
                cancel: () => {
                    this.modal?.modalComponent.close()
                },
                customText: `${i18next.t("interval_setting_intervals")} : ${this.root.root.elname}`,
            };
            $pm.resolveControl(
                this.root.root,
                "IntervalsSettings",
                () => this._onOkClick.call(this),
                options
            );
        } else this._onOkClick.call(this);
    }

    _onOkClick() {
        this.state.division = this.copy.division
        this.state.resampleInterval = this.copy.resampleInterval
        this.state.archivestart = this.copy.archivestart
        this.state.archiveend = this.copy.archiveend
        this.root.root.formattime = this.copy.formattime

        this.root.root.getHistoryData()
        if (this.root.root.intervals) this.root.root.intervals.labelElem.innerHTML = i18next.t("chartcolumn_your_interval")
        this.modal?.modalComponent.close()
    }
    onSelect(e) {
        const value = +e.target.value
        this.selected = value
    }

    onStartChange({ date, formattedDate, datepicker }) {
        const [start] = generateDate(+new Date(date), this.selected)
        this.copy.archivestart = start
    }

    onEndChange({ date, formattedDate, datepicker }) {
        const [_, end] = generateDate(+new Date(date), this.selected)
        this.copy.archiveend = end
    }

    updateCopyValues() {
        this.copy.division = this.state.division
        this.copy.archivestart = this.state.archivestart
        this.copy.archiveend = this.state.archiveend
    }

    render() {
        this.modalContent = this.modal.modalComponent.querySelector('#interval-content')
        this.modalContent.textContent = ''
        const { archivestart, archiveend } = this.copy
        this.modalContent.innerHTML = renderInputs(this.selected, archivestart, archiveend)
        this.select = this.modal.modalComponent.querySelector('#select-value')
        this.select.addEventListener('change', this.onSelect.bind(this))
        this.initDatepicker()
    }

    get selected() {
        return this._selected
    }

    set selected(v) {
        this._selected = v
        const { resampleInterval, division, formattime } = selectValeus[v]
        this.copy.division = division
        this.copy.resampleInterval = resampleInterval
        this.copy.formattime = formattime
        this.render()
    }
}